import { all, call } from "redux-saga/effects"
import { listFetchingFlow } from "./list/actions"

export function* quotationsSaga() {
  yield all([call(listFetchingFlow)])
}

export { fetchQuotationsList } from "./list/actions"
